import { render, staticRenderFns } from "./GetUrl.vue?vue&type=template&id=48bd5e7a&"
import script from "./GetUrl.vue?vue&type=script&lang=js&"
export * from "./GetUrl.vue?vue&type=script&lang=js&"
import style0 from "./GetUrl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports